module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/3_1ad9bedea889b4ab9f8da0ca36e74ae7.png";